
export default function SocialProof() {
  const logos = [
    { name: '自動車部品メーカー', sub: '愛知県', icon: 'ri-car-line' },
    { name: '精密機器工場', sub: '長野県', icon: 'ri-settings-3-line' },
    { name: '溶接・板金加工業', sub: '大阪府', icon: 'ri-tools-line' },
    { name: '物流倉庫', sub: '埼玉県', icon: 'ri-store-2-line' },
  ];

  const testimonials = [
    {
      role: '精密機器加工工場',
      position: '工場長',
      icon: 'ri-factory-line',
      color: 'text-red-600',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      quote:
        '以前、粉末消火器の誤噴射で機械を一台ダメにした経験があります。FIRE OUTは「汚れない」という点で、迷わず全ラインへの配備を決めました。',
    },
    {
      role: '溶接・板金加工業',
      position: '安全管理者',
      icon: 'ri-shield-user-line',
      color: 'text-orange-600',
      bgColor: 'bg-orange-50',
      borderColor: 'border-orange-200',
      quote:
        'スパッタ（火花）によるボヤ騒ぎは日常茶飯事。作業員の腰袋に入るこのサイズ感と、0.5秒で使える操作性が現場で好評です。',
    },
    {
      role: '物流倉庫',
      position: 'センター長',
      icon: 'ri-building-2-line',
      color: 'text-teal-600',
      bgColor: 'bg-teal-50',
      borderColor: 'border-teal-200',
      quote:
        '夏場の倉庫内は40℃を超えます。従来のスプレー缶は破裂が怖くて置けませんでしたが、90℃耐熱のFIRE OUTなら安心して各棚に配置できました。',
    },
  ];

  return (
    <section className="py-24 bg-gray-50" hidden>
      <div className="max-w-6xl mx-auto px-6">
        {/* 見出し */}
        <div className="text-center mb-14">
          <h2
            className="sp-heading text-4xl md:text-5xl font-bold text-gray-900 mb-4"
            style={{ lineHeight: '1.5' }}
          >
            安全基準に厳しい
            <br />
            <span className="text-red-600">「モノづくりの現場」</span>で選ばれています。
          </h2>
          <p className="sp-sub text-lg text-gray-600">
            全国の製造・物流現場から、信頼の声が届いています。
          </p>
        </div>

        {/* ロゴパレード */}
        <div className="mb-16">
          <p className="sp-logo-label text-center text-sm font-semibold text-gray-400 uppercase tracking-widest mb-8">
            導入企業・施設（一部）
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {logos.map((logo, i) => (
              <div
                key={i}
                className="bg-white rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center justify-center py-6 px-4 hover:shadow-md transition-all duration-200"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-full mb-3">
                  <i className={`${logo.icon} text-2xl text-gray-500`}></i>
                </div>
                <p className="sp-logo-name text-sm font-bold text-gray-800 text-center leading-snug">
                  {logo.name}
                </p>
                <p className="text-xs text-gray-400 mt-1">{logo.sub}</p>
              </div>
            ))}
          </div>
        </div>

        {/* お客様の声 3枚カード */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className={`bg-white rounded-2xl shadow-lg border ${t.borderColor} p-8 flex flex-col hover:shadow-xl transition-all duration-300 hover:-translate-y-1`}
            >
              {/* アイコン＋役職 */}
              <div className="flex items-center space-x-3 mb-6">
                <div className={`w-12 h-12 flex items-center justify-center ${t.bgColor} rounded-full`}>
                  <i className={`${t.icon} text-2xl ${t.color}`}></i>
                </div>
                <div>
                  <p className="sp-card-role text-sm font-bold text-gray-800">{t.role}</p>
                  <p className="text-xs text-gray-500">{t.position}</p>
                </div>
              </div>

              {/* 引用符 */}
              <div className={`text-5xl font-serif leading-none ${t.color} mb-2 opacity-30`}>"</div>

              {/* 本文 */}
              <p className="sp-card-quote text-sm text-gray-700 leading-relaxed flex-1">
                {t.quote}
              </p>

              {/* 星 */}
              <div className="flex items-center space-x-1 mt-6">
                {[...Array(5)].map((_, s) => (
                  <i key={s} className="ri-star-fill text-yellow-400 text-base"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .sp-heading {
            font-size: 1.5rem !important;
            line-height: 1.6 !important;
          }
          .sp-sub {
            font-size: 0.85rem !important;
          }
          .sp-logo-label {
            font-size: 0.7rem !important;
          }
          .sp-logo-name {
            font-size: 0.75rem !important;
          }
          .sp-card-role {
            font-size: 0.75rem !important;
          }
          .sp-card-quote {
            font-size: 0.8rem !important;
          }
        }
      `}</style>
    </section>
  );
}
